// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopEventsPage_wrapper_2vcQT"};